import React from 'react';

import Field from 'circe/forms/components/Field';
import mapFieldToInput from 'domain/finance/fuse/components/mapFieldToInput';
import AutoComplete from './AutoComplete';

const mappedFieldToInput = mapFieldToInput(AutoComplete);

export default (props) => <Field component={mappedFieldToInput} {...props} />;
